import PublicPricing from './pages/PublicPricing';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { supabase } from './supabase';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Copilot from './pages/Copilot';
import Pricing from './pages/Pricing';
 
const API = 'https://objectionready-production.up.railway.app';
 
export default function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [subscribed, setSubscribed] = useState(null);
 
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      if (session) checkSubscription(session.user.email);
      else setLoading(false);
    });
 
    supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (session) checkSubscription(session.user.email);
      else { setSubscribed(null); setLoading(false); }
    });
  }, []);
 
  const checkSubscription = async (email) => {
    try {
      const res = await fetch(`${API}/stripe/status`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      setSubscribed(data.active);
    } catch (e) {
      setSubscribed(false);
    }
    setLoading(false);
  };
 
  if (loading) return <div style={{ background: '#0a0a0b', minHeight: '100vh' }}></div>;
 
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/pricing" element={<PublicPricing />} />
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={
          !session ? <Login /> :
          subscribed === null ? <div style={{ background: '#0a0a0b', minHeight: '100vh' }}></div> :
          subscribed ? <Copilot session={session} /> :
          <Pricing session={session} />
        } />
        <Route path="/app" element={
          !session ? <Login /> :
          subscribed === null ? <div style={{ background: '#0a0a0b', minHeight: '100vh' }}></div> :
          subscribed ? <Copilot session={session} /> :
          <Pricing session={session} />
        } />
      </Routes>
    </BrowserRouter>
  );
}